import clonedeep from 'lodash.clonedeep';

export default {
	data() {
		return {
			prevSelectedProducts: [],
			checkForRulesFlag: false,
			ruleAddedProducts: [],
			ruleRemovedProducts: [],
			cachedWorkflow: null,
		};
	},
	methods: {
		getSelectedProducts(workflow) {
			if (!workflow?.length) return;
			return workflow
				.filter((wfs) => wfs?.selected)
				.map((wfs) => wfs.selected.map((selected) => selected.initial))
				.flat()
				.filter((prod) => !prod.includes('custom-product'));
		},
		checkForRuleChanges(workflow) {
			if (!workflow?.length) return;

			const oldVal = this.getPrevSelectedProducts;
			const newVal = this.getSelectedProducts(workflow);

			// update prevSelected
			this.prevSelectedProducts = newVal;

			// check if selected has changed
			if (oldVal.sort().join('') === newVal.sort().join('')) return;

			// reset flag
			this.checkForRulesFlag = false;

			// check for new selected products
			const hasNewSelected = newVal.filter((val) => !oldVal.some((old) => old === val));

			// check for products removed from selected
			const hasRemovedProducts = oldVal.filter((val) => !newVal.some((nu) => nu === val));

			if (hasNewSelected?.length) this.checkProductsForRules(hasNewSelected);
			if (hasRemovedProducts?.length) this.checkProductsForRules(hasRemovedProducts);
		},
		checkProductsForRules(productKeys) {
			// check if a rule has already been found
			if (this.getRulesFlag) return;

			for (const key of productKeys) {
				const product = this.$store.getters['workflow/productById'](key);
				if (product && this.productHasRules(product)) {
					this.checkForRulesFlag = true;
					return this.$root.$emit('exclusionRuleApplied');
				}
			}
		},
		productHasRules(product) {
			return Object.values(product.rules).some((rule) => rule.size > 0);
		},
		async doWeShowRuleModal({wfs, addProduct, removeProduct}) {
			// reset vars
			this.ruleAddedProducts = [];
			this.ruleRemovedProducts = [];
			this.cachedWorkflow = null;

			// clone live workflow
			const currentWorflow = await clonedeep(this.$store.getters['workflow/wfSteps']);

			// reset suggestedProduct flag for product
			if (addProduct && !addProduct.includes('custom-product')) {
				const productToUpdate = wfs.products.find((product) => product.key === addProduct);
				delete productToUpdate.rules.suggestedRan;
			}

			// update the step with new selections
			let newWorkflow = await this.createNewWorkflow(currentWorflow, wfs);

			// run rules on temp workflow
			newWorkflow = await this.$store.dispatch('wfRules/runRules', newWorkflow);

			// build add/remove list
			await this.checkForRuleAddedRemovedProducts(newWorkflow, currentWorflow, addProduct, removeProduct);

			this.cachedWorkflow = newWorkflow;

			// if no product changes commit the change
			if (!this.ruleAddedProducts?.length && !this.ruleRemovedProducts?.length)
				return this.accecptProductRuleChanges();

			this.openProductsAdaptationModal = true;
		},
		async createNewWorkflow(currentWorflow, wfs) {
			const workflow = await clonedeep(currentWorflow);
			const index = workflow.findIndex((w) => w.name === wfs.name);

			workflow[index] = wfs;
			return workflow;
		},
		async checkForRuleAddedRemovedProducts(newWorkflow, currentWorflow, addProduct, removeProduct) {
			const newSelected = this.getSelectedProducts(newWorkflow);
			const currentSelected = this.getSelectedProducts(currentWorflow);

			// check for products that have been removed
			const removedProducts = currentSelected.filter(
				(product) => !newSelected.includes(product) && product !== removeProduct,
			);
			// check for products that have been added
			const addedProducts = newSelected.filter(
				(product) => !currentSelected.includes(product) && product !== addProduct,
			);

			// update removed list
			if (removedProducts?.length) {
				for (const key of removedProducts) {
					const {catalogNumber, name, image, mobileImage, pageLink} = await this.$store.getters[
						'workflow/productById'
					](key);
					this.ruleRemovedProducts.push({catalogNumber, name, image, mobileImage, pageLink});
				}
			}

			// updated added list
			if (addedProducts?.length) {
				for (const key of addedProducts) {
					const {catalogNumber, name, image, mobileImage, pageLink} = await this.$store.getters[
						'workflow/productById'
					](key);
					this.ruleAddedProducts.push({catalogNumber, name, image, mobileImage, pageLink});
				}
			}
			return;
		},
		accecptProductRuleChanges() {
			this.$store.dispatch('workflow/setWfSteps', this.cachedWorkflow);
			this.openProductsAdaptationModal = false;
			this.toggleOptionsModal();
		},
	},
	computed: {
		getPrevSelectedProducts() {
			return this.prevSelectedProducts;
		},
		getRulesFlag() {
			return this.checkForRulesFlag;
		},
	},
	mounted() {
		this.$root.$on('checkForRuleChanges', this.checkForRuleChanges);
	},
};
